import React, { useEffect } from 'react';
import VersionSelector from './VersionSelector';
import { useVersion } from '@/contexts/VersionContext';
import { useVersions } from '@/hooks/useVersions';

interface ContentTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  slug: string; // Add slug prop to fetch versions
}

const ContentTabs: React.FC<ContentTabsProps> = ({ activeTab, onTabChange, slug }) => {
  // Get version context
  const { selectedVersion, setSelectedVersion } = useVersion();
  

  
  // Get versions for this company
  const { versions, loading } = useVersions({ slug, enabled: true });
  
  // Initialize the version when the component mounts
  useEffect(() => {
    console.log('🔄 [ContentTabs] Initializing version');
    console.log('🔄 [ContentTabs] Current state:', {
      selectedVersion,
      versionsCount: versions.length,
      loading
    });
    
    if (!selectedVersion && versions.length > 0 && !loading) {
      // Sort versions by date (newest first)
      const sortedVersions = [...versions].sort((a, b) => 
        b.version.localeCompare(a.version)
      );
      
      // Set the most recent version
      const latestVersion = sortedVersions[0]?.version;
      if (latestVersion) {
        console.log('🔄 [ContentTabs] Setting initial version to latest:', latestVersion);
        setSelectedVersion(latestVersion);
        console.log('✅ [ContentTabs] Initial version set to latest');
      }
    }
  }, [versions, loading, selectedVersion, setSelectedVersion]);
  
  // Define all available tabs in the requested order
  const tabs = [
    { id: 'plans', label: 'Pricing' },
    { id: 'versions', label: 'Versions' },
    { id: 'events', label: 'Pricing Events' }, // Re-enabled with lazy loading
    { id: 'ai', label: 'Ask AI' }
  ];
  
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        {/* <VersionSelector 
          selectedVersion={selectedVersion}
          onVersionChange={(version) => {
            // Update the version in the context
            setSelectedVersion(version);
            
            // Also update any global variables or state that might be needed
            (window as any).currentGlobalVersion = version;
            
            // Dispatch a custom event to notify all components
            const versionChangeEvent = new CustomEvent('versionChange', { 
              detail: { version } 
            });
            window.dispatchEvent(versionChangeEvent);
          }}
        /> */}
      </div>
      <div className="flex overflow-x-auto border-b">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`px-4 py-2 font-medium whitespace-nowrap transition-colors duration-200 ${
              activeTab === tab.id 
                ? 'border-b-2 border-blue-500 text-blue-600' 
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContentTabs;
